import { ensureStoreMetadata, Store, getActionTypeFromInstance } from '@ngxs/store';
import { Injectable, Injector, NgModule, Self } from '@angular/core';
import { filter, map } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
const ɵ0 = /**
 * @param {?} value
 * @return {?}
 */
(value) => value === null, ɵ1 = /**
 * @param {?} value
 * @return {?}
 */
(value) => typeof value === 'undefined' || value === undefined, ɵ2 = /**
 * @param {?} value
 * @return {?}
 */
(value) => value == null, ɵ3 = /**
 * @param {?} value
 * @return {?}
 */
(value) => !!value, ɵ4 = /**
 * @param {?} value
 * @return {?}
 */
(value) => !value, ɵ5 = /**
 * @param {?} value
 * @return {?}
 */
(value) => typeof value === 'string', ɵ6 = /**
 * @param {?} value
 * @return {?}
 */
(value) => typeof value === 'number', ɵ7 = /**
 * @param {?} value
 * @return {?}
 */
(value) => typeof value === 'boolean', ɵ8 = /**
 * @template T
 * @param {?} value
 * @return {?}
 */
(value) => Array.isArray(value);
/** @type {?} */
const is = {
    null: (ɵ0),
    undefined: (ɵ1),
    nullOrUndefined: (ɵ2),
    truthy: (ɵ3),
    falsy: (ɵ4),
    string: (ɵ5),
    number: (ɵ6),
    boolean: (ɵ7),
    array: (ɵ8)
};
/**
 * @template T
 * @param {?} array
 * @return {?}
 */
function flatten(array) {
    if (is.array(array)) {
        return array;
    }
    return [array];
}
/**
 * @param {?} value
 * @return {?}
 */
function isNotAFunction(value) {
    return typeof value !== 'function';
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const ActionStatus = {
    Dispatched: 'DISPATCHED',
    Successful: 'SUCCESSFUL',
    Canceled: 'CANCELED',
    Errored: 'ERRORED',
};
/**
 * Static metadata for the receiver function
 *
 * \@property type - Action type (optional)
 * \@property action - Custom action to dispatch (optional)
 * @record
 * @template T
 */
function ReceiverMetaData() { }
if (false) {
    /** @type {?} */
    ReceiverMetaData.prototype.type;
    /** @type {?} */
    ReceiverMetaData.prototype.payload;
    /** @type {?} */
    ReceiverMetaData.prototype.action;
    /** @type {?} */
    ReceiverMetaData.prototype.cancelUncompleted;
}
/**
 * Plain object that contains helpers that dispatch payload
 *
 * \@property emit - Function that dispatches payload under the hood
 * \@property emitMany - Function that makes multiple dispatching under the hood
 * @record
 * @template T, U
 */
function Emittable() { }
if (false) {
    /**
     * @param {?} payload
     * @return {?}
     */
    Emittable.prototype.emit = function (payload) { };
    /**
     * @param {?} payloads
     * @return {?}
     */
    Emittable.prototype.emitMany = function (payloads) { };
}
/**
 * Basic wrapper around actions
 *
 * \@property status - Status of dispatched action
 * \@property action - Action instance
 * \@property error - Error if happened
 * @record
 */
function ActionContext() { }
if (false) {
    /** @type {?} */
    ActionContext.prototype.status;
    /** @type {?} */
    ActionContext.prototype.action;
    /** @type {?|undefined} */
    ActionContext.prototype.error;
}
/**
 * Action context that maps `ofEmittable` operator
 *
 * \@property type - Action type
 * \@property payload - Dispatched data
 * \@property error - Error that has been throwed or undefined
 * @record
 * @template T
 */
function OfEmittableActionContext() { }
if (false) {
    /** @type {?} */
    OfEmittableActionContext.prototype.type;
    /** @type {?} */
    OfEmittableActionContext.prototype.payload;
    /** @type {?|undefined} */
    OfEmittableActionContext.prototype.error;
}
/**
 * Hashmap that contains types to filter using `ofEmittable` operator
 *
 * \@property key - Any string key
 * @record
 */
function Types() { }
/**
 * @const - This constant is a key for defining static metadata using `\@Receiver`
 * @type {?}
 */
const RECEIVER_META_KEY = 'NGXS_RECEIVER_META';
/**
 * \@internal
 * @template T
 * @param {?} constructors - Array of classes (actions)
 * @param {?} payload - Payload to dispatch
 * @return {?} - Array of instances
 */
function constructEventsForSingleDispatching(constructors, payload) {
    return constructors.map((/**
     * @param {?} Action
     * @return {?}
     */
    Action => new Action(payload)));
}
/**
 * \@internal
 * @template T
 * @param {?} constructors - Array of classes (actions)
 * @param {?} payloads - Payloads to dispatch
 * @return {?} - Array of instances
 */
function constructEventsForManyDispatching(constructors, payloads) {
    /** @type {?} */
    const events = [];
    for (const Action of constructors) {
        for (const payload of payloads) {
            events.push(new Action(payload));
        }
    }
    return events;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@internal
 * @return {?} - Generated hash w/o collisions because it's time-based
 */
function generateHash() {
    return (Math.random() * Date.now()).toString(36).slice(0, 8);
}
/**
 * \@internal
 * @param {?} options - Options passed to the `\@Receiver()` decorator
 * @param {?} target - Decorated target
 * @param {?} key - Decorated key
 * @return {?}
 */
function getActionProperties(options, target, key) {
    /** @type {?} */
    const defaultProperties = {
        type: `[ID:${generateHash()}] ${target.name}.${key}`,
        payload: undefined,
        action: (/** @type {?} */ (undefined)),
        cancelUncompleted: true
    };
    if (is.nullOrUndefined(options)) {
        return defaultProperties;
    }
    const { type, payload, action, cancelUncompleted } = options;
    if (type) {
        defaultProperties.type = type;
    }
    if (payload) {
        defaultProperties.payload = payload;
    }
    if (action) {
        defaultProperties.action = action;
        if (!is.array(action)) {
            defaultProperties.type = action.type;
        }
    }
    if (is.boolean(cancelUncompleted)) {
        defaultProperties.cancelUncompleted = cancelUncompleted;
    }
    return defaultProperties;
}
/**
 * Decorates a method with a receiver information
 *
 * @param {?=} options - Options for configuring static metadata
 * @return {?} - Factory for decorating method
 */
function Receiver(options) {
    return (/**
     * @param {?} target
     * @param {?} key
     * @param {?} descriptor
     * @return {?}
     */
    (target, key, descriptor) => {
        /** @type {?} */
        const isNotFunctionOrNotStatic = is.undefined(target.prototype) || is.falsy(descriptor) || isNotAFunction(target[key]);
        if (isNotFunctionOrNotStatic) {
            throw new TypeError(`Only static functions can be decorated with @Receiver() decorator`);
        }
        /** @type {?} */
        const reservedKeyAlreadyExists = key in target.prototype;
        if (reservedKeyAlreadyExists) {
            throw new Error(`Property with name \`${key.toString()}\` already exists, please rename to avoid conflicts`);
        }
        if (typeof key !== 'string') {
            key = String(key);
        }
        /** @type {?} */
        const meta = ensureStoreMetadata(target);
        const { type, payload, action, cancelUncompleted } = getActionProperties(options, target, key);
        if (meta.actions.hasOwnProperty(type)) {
            throw new Error(`Method decorated with such type \`${type}\` already exists`);
        }
        if (is.array(action)) {
            for (const { type } of action) {
                meta.actions[type] = [
                    {
                        fn: `${key}`,
                        options: { cancelUncompleted },
                        type
                    }
                ];
            }
        }
        else {
            meta.actions[type] = [
                {
                    fn: `${key}`,
                    options: { cancelUncompleted },
                    type
                }
            ];
        }
        (/** @type {?} */ (descriptor.value))[RECEIVER_META_KEY] = {
            type,
            action,
            payload
        };
        target.prototype[key] = (/**
         * @param {?} ctx
         * @param {?} action
         * @return {?}
         */
        function (ctx, action) {
            return target[key].call(target, ctx, action);
        });
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This class is used as a default action when
 * the user doesn't pass any custom action as an argument
 * @template T
 */
class EmitterAction {
    /**
     * Creates EmitterAction instance
     *
     * @param {?} payload - Data to dispatch
     * @param {?=} type - Action type
     */
    constructor(payload, type = null) {
        this.payload = payload;
        this.type = type;
    }
}
if (false) {
    /** @type {?} */
    EmitterAction.prototype.payload;
    /** @type {?} */
    EmitterAction.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EmitStore extends Store {
    /**
     * @template T, U
     * @param {?} receiver - Reference to the static function from the store
     * @return {?} - A plain object with an `emit` function for calling emitter
     */
    emitter(receiver) {
        /** @type {?} */
        const metadata = receiver[RECEIVER_META_KEY];
        if (is.falsy(metadata)) {
            throw new Error(`Static metadata cannot be found, have you decorated ${receiver.name} with @Receiver()?`);
        }
        return {
            emit: (/**
             * @param {?} payload
             * @return {?}
             */
            (payload) => this.dispatchSingle(metadata, payload)),
            emitMany: (/**
             * @param {?} payloads
             * @return {?}
             */
            (payloads) => this.dispatchMany(metadata, payloads))
        };
    }
    /**
     * @private
     * @template T, U
     * @param {?} metadata - Receiver function metadata
     * @param {?} payload - Data to dispatch
     * @return {?} - An observable that emits events after dispatch
     */
    dispatchSingle(metadata, payload) {
        if (is.undefined(payload) && metadata.payload !== undefined) {
            payload = metadata.payload;
        }
        const { action } = metadata;
        if (action) {
            /** @type {?} */
            const flattenedConstructors = flatten(action);
            return this.dispatch(constructEventsForSingleDispatching(flattenedConstructors, payload));
        }
        return this.dispatch(new EmitterAction(payload, metadata.type));
    }
    /**
     * @private
     * @template T, U
     * @param {?} metadata - Receiver function metadata
     * @param {?} payloads - Array with data to dispatch
     * @return {?} - An observable that emits events after dispatch
     */
    dispatchMany(metadata, payloads) {
        if (!is.array(payloads)) {
            return this.dispatch([]);
        }
        const { action } = metadata;
        if (action) {
            /** @type {?} */
            const flattenedConstructors = flatten(action);
            return this.dispatch(constructEventsForManyDispatching(flattenedConstructors, payloads));
        }
        return this.dispatch(payloads.map((/**
         * @param {?} payload
         * @return {?}
         */
        payload => new EmitterAction(payload, metadata.type))));
    }
}
EmitStore.ɵfac = function EmitStore_Factory(t) { return ɵEmitStore_BaseFactory(t || EmitStore); };
EmitStore.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EmitStore, factory: EmitStore.ɵfac });
const ɵEmitStore_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(EmitStore);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmitStore, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxsEmitPluginModuleIsNotImported extends Error {
    constructor() {
        super(`You've forgotten to import \`NgxsEmitPluginModule\``);
    }
}
/**
 * Allows multiple decorators to get access to the DI store
 */
class InjectorAccessor {
    /**
     * Creates InjectorAccessor instance
     *
     * @param {?} injector - Root injector
     */
    constructor(injector) {
        InjectorAccessor.injector = injector;
    }
    /**
     * @return {?}
     */
    static getEmitStore() {
        if (is.null(this.injector)) {
            throw new NgxsEmitPluginModuleIsNotImported();
        }
        return this.injector.get(EmitStore);
    }
}
InjectorAccessor.ɵfac = function InjectorAccessor_Factory(t) { return new (t || InjectorAccessor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
InjectorAccessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: InjectorAccessor, factory: InjectorAccessor.ɵfac });
/**
 * Injector for accessing DI
 */
InjectorAccessor.injector = null;
/** @nocollapse */
InjectorAccessor.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InjectorAccessor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();
if (false) {
    /**
     * Injector for accessing DI
     * @type {?}
     * @private
     */
    InjectorAccessor.injector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Decorates a property and defines new getter
 *
 * @param {?} receiver - Reference to the static function
 * @return {?} - Factory function for decorating properties
 */
function Emitter(receiver) {
    return (/**
     * @param {?} target
     * @param {?} key
     * @return {?}
     */
    (target, key) => {
        Object.defineProperty(target, key, {
            get: (/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const store = InjectorAccessor.getEmitStore();
                return store.emitter(receiver);
            })
        });
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EmitterService {
    /**
     * @param {?} emitStore
     */
    constructor(emitStore) {
        this.emitStore = emitStore;
    }
    /**
     * @template T, U
     * @param {?} receiver
     * @return {?}
     */
    action(receiver) {
        return this.emitStore.emitter(receiver);
    }
}
EmitterService.ɵfac = function EmitterService_Factory(t) { return new (t || EmitterService)(ɵngcc0.ɵɵinject(EmitStore)); };
EmitterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EmitterService, factory: EmitterService.ɵfac });
/** @nocollapse */
EmitterService.ctorParameters = () => [
    { type: EmitStore }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmitterService, [{
        type: Injectable
    }], function () { return [{ type: EmitStore }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    EmitterService.prototype.emitStore;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxsEmitPluginModule {
    /**
     * @param {?} injectorAccessor
     */
    constructor(injectorAccessor) {
        this.injectorAccessor = injectorAccessor;
    }
    /**
     * @return {?} - A wrapper around `NgModule`
     */
    static forRoot() {
        return {
            ngModule: NgxsEmitPluginModule,
            providers: [EmitStore, EmitterService, InjectorAccessor]
        };
    }
}
NgxsEmitPluginModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxsEmitPluginModule });
NgxsEmitPluginModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxsEmitPluginModule_Factory(t) { return new (t || NgxsEmitPluginModule)(ɵngcc0.ɵɵinject(InjectorAccessor, 2)); } });
/** @nocollapse */
NgxsEmitPluginModule.ctorParameters = () => [
    { type: InjectorAccessor, decorators: [{ type: Self }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxsEmitPluginModule, [{
        type: NgModule
    }], function () { return [{ type: InjectorAccessor, decorators: [{
                type: Self
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    NgxsEmitPluginModule.prototype.injectorAccessor;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * `getReceiverTypes([CounterState.increment, CounterState.decrement])`
 * will return a hashmap => `{ 'CounterState.increment': true, 'CounterState.decrement': true }`
 *
 * @param {?} receivers - Array with references to the static functions
 * @return {?} - A key-value map where a key is a type and value is `true`
 */
function getReceiverTypes(receivers) {
    /** @type {?} */
    const types = {};
    for (const receiver of receivers) {
        if (isNotAFunction(receiver)) {
            throw new TypeError(`Receiver should be a function, got ${receiver}`);
        }
        /** @type {?} */
        const meta = receiver[RECEIVER_META_KEY];
        if (is.falsy(meta) || is.falsy(meta.type)) {
            throw new Error(`${receiver.name} should be decorated with @Receiver() decorator`);
        }
        types[meta.type] = true;
    }
    return types;
}
/**
 * @param {...?} receivers - Array with references to the static functions decorated with `\@Receiver()`
 * @return {?}
 */
function ofEmittableDispatched(...receivers) {
    return ofEmittable(getReceiverTypes(receivers), "DISPATCHED" /* Dispatched */);
}
/**
 * @param {...?} receivers - Array with references to the static functions decorated with `\@Receiver()`
 * @return {?}
 */
function ofEmittableSuccessful(...receivers) {
    return ofEmittable(getReceiverTypes(receivers), "SUCCESSFUL" /* Successful */);
}
/**
 * @param {...?} receivers - Array with references to the static functions decorated with `\@Receiver()`
 * @return {?}
 */
function ofEmittableCanceled(...receivers) {
    return ofEmittable(getReceiverTypes(receivers), "CANCELED" /* Canceled */);
}
/**
 * @param {...?} receivers - Array with references to the static functions decorated with `\@Receiver()`
 * @return {?}
 */
function ofEmittableErrored(...receivers) {
    return ofEmittable(getReceiverTypes(receivers), "ERRORED" /* Errored */);
}
/**
 * @param {?} types - Hashmap that contains action types
 * @param {?} status - Status of the dispatched action
 * @return {?} - RxJS factory operator function
 */
function ofEmittable(types, status) {
    return (/**
     * @param {?} source
     * @return {?}
     */
    source => source.pipe(filter((/**
     * @param {?} ctx
     * @return {?}
     */
    (ctx) => {
        /** @type {?} */
        const type = (/** @type {?} */ (getActionTypeFromInstance(ctx.action)));
        /** @type {?} */
        const hashMapHasType = !!types[type];
        /** @type {?} */
        const contextHasTransmittedStatus = ctx.status === status;
        return hashMapHasType && contextHasTransmittedStatus;
    })), map((/**
     * @param {?} __0
     * @return {?}
     */
    ({ action, error }) => (/** @type {?} */ ({
        error,
        type: getActionTypeFromInstance(action),
        payload: action.payload
    }))))));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Emitter, EmitterAction, EmitterService, NgxsEmitPluginModule, Receiver, ofEmittableCanceled, ofEmittableDispatched, ofEmittableErrored, ofEmittableSuccessful, ofEmittable as ɵb, InjectorAccessor as ɵc, EmitStore as ɵd };

//# sourceMappingURL=ngxs-labs-emitter.js.map